export default {
  app: {
    privacy: {
      policy: '개인정보 처리방침',
      expansive: 'Expansive를 사용하면 Expansive {action}에 동의하게 됩니다',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: '세션이 만료되었습니다',
    sessionExpiredDescription: '세션이 만료되었습니다. 계속 사용하려면 다시 로그인해 주세요.',
  },
  components: {
    appContainer: {
      chooseLanguage: '언어 선택',
      chooseLanguageDescription:
        '앱에서 사용할 선호 언어를 선택하세요. 인터페이스와 콘텐츠의 언어가 변경됩니다.',
    },
    userSelection: {
      cancel: '취소',
      createNewUser: '이름이 목록에 없습니다',
      newUser: '새 사용자',
      selectAnExistingUser: '기존 사용자 선택',
      selectUserHint: '계속하려면 기존 사용자를 선택하거나 새 사용자를 생성하세요.',
      startTypingToSearch: '검색하려면 입력을 시작하세요...',
    },
    verification: {
      codeVerification: {
        continue: '계속',
        header: '현장 접근 코드 입력',
        invalidCode: '잘못된 코드입니다. 다시 시도해 주세요.',
      },
      geoVerification: {
        continueWithoutVerifying: '위치 확인 없이 계속',
        enterSiteAccessCode: '현장 접근 코드 입력',
        locationNotEnabledOrAvailable: '왜 이것이 표시되나요?',
        notAvailable: {
          description: '이 기기에서는 GPS 위치가 지원되지 않습니다.',
          header: '위치가 지원되지 않음',
        },
        notEnabled: {
          description: '위치 서비스가 활성화되지 않았거나 권한이 부여되지 않았습니다.',
          header: '위치가 활성화되지 않음',
        },
        notVerified: {
          description: 'GPS에 따르면 현장에 있지 않습니다.',
          header: '위치 미확인',
        },
        tryAgain: '다시 시도',
        unavailable: {
          description: 'GPS 위치를 확인할 수 없습니다.',
          header: '위치 확인 불가',
        },
        unknown: {
          description: '위치를 확인할 수 없습니다.',
          header: '알 수 없는 위치',
        },
        verified: {
          description: 'GPS에 따르면 현장에 있습니다.',
          header: '위치 확인됨',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: '자산이 없습니다',
        emptyDescription: '이 작업 지시와 연결된 자산이 없습니다.',
        warrantyParts: '부품 보증 만료',
        serialNumber: '일련 번호',
        none: '<없음>',
      },
      updates: {
        emptyTitle: '업데이트가 없습니다',
        emptyDescription: '이 작업 지시에 대한 업데이트가 없습니다.',
        unknownUser: '알 수 없는 사용자',
        none: '없음',
        addComment: {
          buttonLabel: '댓글 추가',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: '위험 요소',
          no: '아니요',
          yes: '예',
        },
      },
    },
    attachmentsList: {
      attachments: '첨부 파일',
      documents: '문서',
      siteDocuments: '현장 문서',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: '위험 요소',
        induction: '오리엔테이션',
        safeToProceed: '진행해도 안전',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: '마감일',
        activeSessions: '활성 세션',
        activeSessionsDescription:
          '다음 작업 지시에 이미 체크인되어 있습니다. 새 작업 지시에 체크인하려면 이 작업 지시에서 체크아웃해야 합니다.',
        resumeSession: '재개',
        startTime: '시작 시간',
        unexpectedErrorTitle: '예기치 않은 오류',
        unexpectedErrorMessage:
          '세션을 생성하는 동안 예기치 않은 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
        engineerNotFound: '엔지니어를 찾을 수 없습니다',
        engineerNotFoundDescription:
          '체크인하려는 엔지니어가 시스템에 없습니다. 관리자에게 문의해 주세요.',
      },
      verification: {
        code: {
          description:
            '체크인하려면 현장 관리자 또는 지정된 담당자에게서 4자리 코드를 받아야 합니다.',
        },
        geo: {
          continue: '계속',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              '방문을 완료하려면 현장 관리자 또는 지정된 연락처에서 액세스 코드를 받아 주세요.',
            checkOut: '체크아웃',
            completeBeforeLeaving: '떠나기 전에 다음 양식을 작성해 주세요.',
            continue: '계속',
            noResolutionSelected: '계속하기 전에 해결책을 선택해 주세요.',
            quoteRequired: {
              hint: '방문 완료, 견적 후속 조치',
              label: '견적 필요',
            },
            returnVisitRequired: {
              hint: '다시 방문하여 완료 예정',
              label: '재방문 필요',
            },
            serviceCompleted: {
              hint: '추가 작업 필요 없음',
              label: '서비스 완료',
            },
            uploadCheckout: '파일, 사진 또는 비디오 업로드',
            visitNotes: '방문 노트',
            workOrderResolution: '작업 지시 해결책',
            enterNotes: '여기에 노트를 입력해 주세요...',
            errors: {
              timedOut: '시간 초과, 30초를 초과했습니다. 다시 시도해 주세요.',
              closingSession: '세션 종료 오류',
            },
          },
          success: {
            description:
              '{site}에 대한 방문이 성공적으로 체크아웃되었습니다. | {site}에 대한 남은 열린 작업 지시가 1개 있습니다. | {site}에 대한 남은 열린 작업 지시가 {count}개 있습니다.',
            endVisit: '방문 종료',
            header: '성공적으로 체크아웃되었습니다',
            viewWorkOrders: '다른 작업 지시에 체크인',
          },
          verification: {
            code: {
              description:
                '체크아웃하려면 현장 관리자 또는 지정된 담당자에게서 4자리 코드를 받아야 합니다.',
              continue: '계속',
            },
            geo: {
              checkOut: '체크아웃',
              continue: '계속',
            },
          },
        },
        detail: {
          assets: '자산',
          call: '전화',
          checkOut: '체크아웃',
          closed: '닫힘',
          details: '세부정보',
          dueBy: '마감일',
          manageEngineers: '엔지니어 관리',
          notAvailable: '사용 불가',
          pointOfContact: '연락처',
          siteAccessTimes: '현장 접근 시간',
          siteAccessInstructions: '접근 안내',
          siteAddress: '현장 주소',
          siteNotes: '현장 노트',
          siteTelephone: '현장 전화',
          siteLocation: '현장 위치',
          updates: '업데이트',
          more: '더보기',
          mismatchErrorTitle: '작업 지시 오류',
          mismatchErrorMessage:
            '접근하려는 작업 지시가 현재 체크인한 작업 지시와 일치하지 않습니다. 작업 지시를 확인하고 다시 시도해 주세요.',
          siteDocuments: '현장 문서',
          validFrom: '유효 시작일',
          validUntil: '유효 종료일',
          documentName: '문서 이름',
          documentType: '문서 유형',
          attachments: '작업 지시 파일',
          download: '다운로드',
          workDetails: '작업 세부정보',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: '보조 엔지니어 추가',
            assistantEngineers: '보조 엔지니어',
            description: '보안상의 이유로 현장에 있는 각 엔지니어의 이름을 지정해 주세요.',
            editMainEngineer: '주 엔지니어 편집',
            errors: {
              creatingEngineer: '엔지니어 생성 오류',
              creatingSession: '세션 생성 오류',
            },
            header: '현장 엔지니어',
            mainEngineer: '주 엔지니어',
            newAssistantEngineer: '그들의 전체 이름 입력',
            next: '다음',
            removeEngineer: '엔지니어 제거',
            selectExistingAssistantEngineer: '이름 입력 시작',
          },
          index: {
            description: '보안상의 이유로 현장에 있는 각 엔지니어의 이름을 지정해 주세요.',
            errorCreatingEngineer: '엔지니어 생성 오류, 다시 시도해 주세요.',
            header: '현장 엔지니어',
            hintMainEngineer: '주 엔지니어의 전체 이름 입력',
            newMainEngineer: '새 주 엔지니어',
            next: '다음',
            selectExistingMainEngineer: '기존 주 엔지니어 선택',
            yes: '예',
            no: '아니요',
            mainEngineerLabel: '당신이 주 엔지니어인가요?',
          },
        },
        index: {
          callUsOn: '{phoneNumber}으로 전화해 주세요',
          description: '원하는 정보를 찾을 수 없나요?',
          dueBy: '마감일',
          header: '작업 지시 선택',
          notAvailable: '사용 불가',
          searchWorkOrders: '작업 지시 검색...',
        },
        manageEngineers: {
          manageEngineers: '엔지니어 관리',
          notWorking: '비활성 작업자',
          pause: '일시 중지',
          resume: '재개',
          workingNow: '활성 작업자',
          startTime: '시작 시간',
          endTime: '종료 시간',
          duration: '지속 시간',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: '피드백',
            feedbackDescription: '작업 지시에 대한 피드백을 제공하여 서비스 개선에 도움을 주세요.',
            feedbackLabel: '피드백',
            filesLabel: '첨부 파일',
            submissionLabel: '피드백 제출',
          },
          hazards: {
            back: '뒤로 가기',
            hazards: '위험 요소',
            next: '다음',
            no: '아니요',
            noTasksForHazard: '이 위험 요소에 대한 완료할 작업이 없습니다.',
            yes: '예',
          },
          induction: {
            continue: '계속',
            induction: '오리엔테이션',
          },
          index: {
            checkIn: '체크인',
            description: '선택한 작업에 대한 위험 평가를 완료해 주세요.',
            fail: '작업 지시 시작 검사 처리 실패.',
            haltMessage:
              '잠재적 위험이 감지되었습니다. 작업을 중단하고, 안전 지침을 검토한 후, 추가 지침을 위해 감독자에게 연락해 주세요.',
            header: '작업 시작 검사',
            endVisit: '방문 종료',
            leaveFeedback: '피드백 남기기',
          },
          safeToProceed: {
            continue: '계속',
            safeToProceed: '진행해도 안전',
          },
        },
      },
    },
    index: {
      title: '환영합니다',
      description: '시작하려면 귀하의 위치에서 QR 코드를 스캔하세요.',
    },
    login: {
      errorTitle: '예기치 않은 오류',
      errorMessage: '예기치 않은 오류가 발생했습니다. QR 코드를 다시 스캔해 주세요.',
    },
    unauthenticated: {
      welcome: {
        title: '{site}에 오신 것을 환영합니다',
        description:
          '작업 지시를 보여주기 전에 귀하의 세부 정보를 확인해야 합니다. 계속하려면 아래 버튼을 클릭해 주세요.',
        next: '계속',
      },
      index: {
        errorTitle: '예기치 않은 오류',
        errorMessage: '예기치 않은 오류가 발생했습니다. QR 코드를 다시 스캔해 주세요.',
      },
      contractor: {
        title: '어디서 일하십니까?',
        contractor: '계약자',
        contractorLabel: '회사 이름 입력 시작',
        contractorHint: '결과를 보려면 3자 이상 입력해야 합니다',
        defaultSelectPlaceholder: '--선택해 주세요--',
        next: '다음',
      },
      user: {
        title: '당신은 누구입니까?',
        cancel: '취소',
        createNewUserLabel: '내 이름이 목록에 없습니다',
        existingUserLabel: '이름 입력 시작',
        existingUserHint: '결과를 보려면 3자 이상 입력해야 합니다',
        newUserLabel: '전체 이름 입력',
        next: '다음',
        user: '사용자',
      },
      verification: {
        methods: {
          add: {
            add: '확인 방법 추가',
            defaultSelectPlaceholder: '--선택해 주세요--',
            emailLabel: '이메일',
            existingMethodWarning:
              '이 확인 방법에 대한 대기 중인 요청이 이미 있습니다. 새로 추가하면 기존 요청이 덮어쓰여집니다.',
            method: '방법',
            methodLabel: '방법',
            mobileCountryHint: '국가 코드를 선택해 주세요',
            mobileCountryLabel: '모바일 국가 코드',
            mobileHint: '모바일 번호를 입력해 주세요',
            mobileLabel: '모바일',
            title: '확인 방법 추가',
          },
          confirm: {
            confirm: '확인',
            description: '계속하려면 확인 방법을 확인해 주세요.',
            label: '코드 입력',
            resend: '재전송',
            resendPrompt: '코드를 받지 못하셨나요?',
            title: '확인 방법 확인',
          },
          confirmed: {
            description:
              '이 확인 방법이 관리자에 의해 승인되면 알림을 받게 되며, 그때부터 이 방법을 사용하여 본인 확인을 할 수 있습니다.',
            forceApproval: '승인될 때까지 작업 지시에 접근할 수 없습니다.',
            nonForceApproval: '그동안 제한된 접근으로 작업 지사에 계속 접근할 수 있습니다.',
            nonForceApprovalButtonLabel: '제한된 접근으로 계속',
            title: '승인 대기 중',
          },
          addNew: '새 확인 방법 추가',
          description: '작업 지시에 대한 전체 접근을 위해 귀하의 신원을 확인해야 합니다.',
          email: '이메일',
          hint: '선택한 확인 방법으로 링크가 전송되어 작업 지사에 대한 전체 접근이 가능합니다. 기존 확인 방법을 변경해야 하는 경우 관리자에게 문의해 주세요.',
          label: '확인 방법 선택',
          next: '다음',
          pendingHint: '관리자의 승인을 기다리고 있습니다',
          sms: 'SMS',
          title: '확인',
        },
        optional: {
          hint: '사용자 세부 정보를 확인하면 작업 지사에 대한 전체 접근이 가능합니다',
          label: '사용자 세부 정보를 확인하시겠습니까?',
          next: '다음',
          no: '아니요',
          noHint: '사용자 세부 정보를 확인하지 않고 작업 지사에 대한 제한된 접근으로 계속합니다',
          title: '확인',
          yes: '예',
          yesHint: '사용자 세부 정보를 확인하여 작업 지사에 대한 전체 접근을 원합니다',
        },
        sent: {
          description:
            '{identifier}로 로그인 링크가 전송되었습니다. 링크를 클릭하여 로그인을 완료해 주세요.',
          title: '로그인 링크 전송됨',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: '어제',
      today: '오늘',
      days: {
        monday: '월요일',
        tuesday: '화요일',
        wednesday: '수요일',
        thursday: '목요일',
        friday: '금요일',
        saturday: '토요일',
        sunday: '일요일',
      },
      months: {
        january: '1월',
        february: '2월',
        march: '3월',
        april: '4월',
        may: '5월',
        june: '6월',
        july: '7월',
        august: '8월',
        september: '9월',
        october: '10월',
        november: '11월',
        december: '12월',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: '문제가 발생했습니다',
      message: 'QR 코드를 다시 스캔해 주세요.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: '알 수 없는 사용자',
      },
      none: '없음',
      types: {
        stateTransition: '상태 변경',
        contractorAssigned: '계약자 지정',
        engineerAssigned: '엔지니어 지정',
        serviceAssigned: '서비스 지정',
        priorityChanged: '우선순위 변경',
        actionableDateChanged: '조치 가능 날짜 변경',
        dueDateChanged: '마감일 변경',
        etaDateChanged: '예상 도착 시간 변경',
        spendLimitApproved: '지출 한도 승인',
        spendLimitCancelled: '지출 한도 요청 취소',
        spendLimitRejected: '지출 한도 거부',
        spendLimitRequested: '지출 한도 요청',
        jobSheetUploaded: '작업 시트 업로드',
        slaAlertSent: '응답 시간 초과 SLA 경고',
        issuedWorkPermit: '작업 허가증 발급',
        requestForServiceSent: '서비스 요청 전송',
        comment: '댓글 추가',
        unknown: '알 수 없는 이벤트',
      },
      labels: {
        actionableDate: '조치 가능 날짜',
        comment: '댓글',
        file: '파일',
        contractor: '계약자',
        dueDate: '마감일',
        etaDate: '예상 도착 시간',
        engineer: '엔지니어',
        priority: '우선순위',
        requestForService: '서비스 요청',
        service: '서비스',
        spendLimit: '지출 한도',
        status: '상태',
        workPermit: '작업 허가증',
      },
    },
  },
}
